export const getComunaId = (regionCode?: string, city?: string): string => {
    if (!regionCode || !city) return ''
    const region = regionComunas.find((region) => region.code === regionCode)
    return region?.comunas.find((comuna) => comuna.name === city)?.id || ''
}

export const regionComunas = [
    {
        name: 'AYSÉN DEL GENERAL CARLOS IBÁÑEZ DEL CAMPO',
        comunas: [
            {
                name: 'AYSEN',
                id: '5611201'
            },
            {
                name: 'COYHAIQUE',
                id: '5611101'
            }
        ],
        id: '11',
        code: 'AY'
    },
    {
        name: 'ANTOFAGASTA',
        comunas: [
            {
                name: 'ANTOFAGASTA',
                id: '5602101'
            },
            {
                name: 'CALAMA',
                id: '5602201'
            },
            {
                name: 'MARIA ELENA',
                id: '5602302'
            },
            {
                name: 'MEJILLONES',
                id: '5602102'
            },
            {
                name: 'OLLAGUE',
                id: '5602202'
            },
            {
                name: 'SAN PEDRO DE ATACAMA',
                id: '5602203'
            },
            {
                name: 'SIERRA GORDA',
                id: '5602103'
            },
            {
                name: 'TALTAL',
                id: '5602104'
            },
            {
                name: 'TOCOPILLA',
                id: '5602301'
            }
        ],
        id: '2',
        code: 'AN'
    },
    {
        name: 'ARICA Y PARINACOTA',
        comunas: [
            {
                name: 'ARICA',
                id: '5615101'
            }
        ],
        id: '15',
        code: 'AP'
    },
    {
        name: 'ATACAMA',
        comunas: [
            {
                name: 'ALTO DEL CARMEN',
                id: '5603302'
            },
            {
                name: 'CALDERA',
                id: '5603102'
            },
            {
                name: 'CHAÑARAL',
                id: '5603201'
            },
            {
                name: 'COPIAPO',
                id: '5603101'
            },
            {
                name: 'DIEGO DE ALMAGRO',
                id: '5603202'
            },
            {
                name: 'FREIRINA',
                id: '5603303'
            },
            {
                name: 'HUASCO',
                id: '5603304'
            },
            {
                name: 'TIERRA AMARILLA',
                id: '5603103'
            },
            {
                name: 'VALLENAR',
                id: '5603301'
            }
        ],
        id: '3',
        code: 'AT'
    },
    {
        name: 'BIOBÍO',
        comunas: [
            {
                name: 'ALTO BIOBIO',
                id: '5608314'
            },
            {
                name: 'ANTUCO',
                id: '5608302'
            },
            {
                name: 'ARAUCO',
                id: '5608202'
            },
            {
                name: 'CABRERO',
                id: '5608303'
            },
            {
                name: 'CANETE',
                id: '5608203'
            },
            {
                name: 'CHIGUAYANTE',
                id: '5608103'
            },
            {
                name: 'CONCEPCION',
                id: '5608101'
            },
            {
                name: 'CONTULMO',
                id: '5608204'
            },
            {
                name: 'CORONEL',
                id: '5608102'
            },
            {
                name: 'CURANILAHUE',
                id: '5608205'
            },
            {
                name: 'FLORIDA',
                id: '5608104'
            },
            {
                name: 'HUALPEN',
                id: '5608112'
            },
            {
                name: 'HUALQUI',
                id: '5608105'
            },
            {
                name: 'LAJA',
                id: '5608304'
            },
            {
                name: 'LEBU',
                id: '5608201'
            },
            {
                name: 'LOS ALAMOS',
                id: '5608206'
            },
            {
                name: 'LOS ANGELES',
                id: '5608301'
            },
            {
                name: 'LOTA',
                id: '5608106'
            },
            {
                name: 'MULCHEN',
                id: '5608305'
            },
            {
                name: 'NACIMIENTO',
                id: '5608306'
            },
            {
                name: 'NEGRETE',
                id: '5608307'
            },
            {
                name: 'PENCO',
                id: '5608107'
            },
            {
                name: 'QUILACO',
                id: '5608308'
            },
            {
                name: 'QUILLECO',
                id: '5608309'
            },
            {
                name: 'SAN PEDRO DE LA PAZ',
                id: '5608108'
            },
            {
                name: 'SAN ROSENDO',
                id: '5608310'
            },
            {
                name: 'SANTA BARBARA',
                id: '5608311'
            },
            {
                name: 'SANTA JUANA',
                id: '5608109'
            },
            {
                name: 'TALCAHUANO',
                id: '5608110'
            },
            {
                name: 'TIRUA',
                id: '5608207'
            },
            {
                name: 'TOME',
                id: '5608111'
            },
            {
                name: 'TUCAPEL',
                id: '5608312'
            },
            {
                name: 'YUMBEL',
                id: '5608313'
            }
        ],
        id: '8',
        code: 'BI'
    },
    {
        name: 'COQUIMBO',
        comunas: [
            {
                name: 'ANDACOLLO',
                id: '5604103'
            },
            {
                name: 'CANELA',
                id: '5604202'
            },
            {
                name: 'COMBARBALA',
                id: '5604302'
            },
            {
                name: 'COQUIMBO',
                id: '5604102'
            },
            {
                name: 'ILLAPEL',
                id: '5604201'
            },
            {
                name: 'LA HIGUERA',
                id: '5604104'
            },
            {
                name: 'LA SERENA',
                id: '5604101'
            },
            {
                name: 'LOS VILOS',
                id: '5604203'
            },
            {
                name: 'MONTE PATRIA',
                id: '5604303'
            },
            {
                name: 'OVALLE',
                id: '5604301'
            },
            {
                name: 'PUNITAQUI',
                id: '5604304'
            },
            {
                name: 'RIO HURTADO',
                id: '5604305'
            },
            {
                name: 'SALAMANCA',
                id: '5604204'
            },
            {
                name: 'VICUÑA',
                id: '5604106'
            }
        ],
        id: '4',
        code: 'CO'
    },
    {
        name: 'LA ARAUCANÍA',
        comunas: [
            {
                name: 'ANGOL',
                id: '5609201'
            },
            {
                name: 'CARAHUE',
                id: '5609102'
            },
            {
                name: 'CHOLCHOL',
                id: '5609121'
            },
            {
                name: 'COLLIPULLI',
                id: '5609202'
            },
            {
                name: 'CUNCO',
                id: '5609103'
            },
            {
                name: 'CURACAUTIN',
                id: '5609203'
            },
            {
                name: 'FREIRE',
                id: '5609105'
            },
            {
                name: 'GALVARINO',
                id: '5609106'
            },
            {
                name: 'GORBEA',
                id: '5609107'
            },
            {
                name: 'LAUTARO',
                id: '5609108'
            },
            {
                name: 'LONCOCHE',
                id: '5609109'
            },
            {
                name: 'LONQUIMAY',
                id: '5609205'
            },
            {
                name: 'NUEVA IMPERIAL',
                id: '5609111'
            },
            {
                name: 'PADRE LAS CASAS',
                id: '5609112'
            },
            {
                name: 'PERQUENCO',
                id: '5609113'
            },
            {
                name: 'PITRUFQUEN',
                id: '5609114'
            },
            {
                name: 'PUCON',
                id: '5609115'
            },
            {
                name: 'PUREN',
                id: '5609208'
            },
            {
                name: 'RENAICO',
                id: '5609209'
            },
            {
                name: 'TEMUCO',
                id: '5609101'
            },
            {
                name: 'TEODORO SCHMIDT',
                id: '5609117'
            },
            {
                name: 'TOLTEN',
                id: '5609118'
            },
            {
                name: 'TRAIGUEN',
                id: '5609210'
            },
            {
                name: 'VICTORIA',
                id: '5609211'
            },
            {
                name: 'VILCUN',
                id: '5609119'
            },
            {
                name: 'VILLARRICA',
                id: '5609120'
            }
        ],
        id: '9',
        code: 'AR'
    },
    {
        name: "LIBERTADOR GENERAL BERNARDO O'HIGGINS",
        comunas: [
            {
                name: 'CHEPICA',
                id: '5606302'
            },
            {
                name: 'CHIMBARONGO',
                id: '5606303'
            },
            {
                name: 'CODEGUA',
                id: '5606102'
            },
            {
                name: 'COINCO',
                id: '5606103'
            },
            {
                name: 'COLTAUCO',
                id: '5606104'
            },
            {
                name: 'DOÑIHUE',
                id: '5606105'
            },
            {
                name: 'GRANEROS',
                id: '5606106'
            },
            {
                name: 'LAS CABRAS',
                id: '5606107'
            },
            {
                name: 'LOLOL',
                id: '5606304'
            },
            {
                name: 'MACHALI',
                id: '5606108'
            },
            {
                name: 'MALLOA',
                id: '5606109'
            },
            {
                name: 'MOSTAZAL',
                id: '5606110'
            },
            {
                name: 'NANCAGUA',
                id: '5606305'
            },
            {
                name: 'NAVIDAD',
                id: '5606205'
            },
            {
                name: 'PALMILLA',
                id: '5606306'
            },
            {
                name: 'PERALILLO',
                id: '5606307'
            },
            {
                name: 'PEUMO',
                id: '5606112'
            },
            {
                name: 'PICHIDEGUA',
                id: '5606113'
            },
            {
                name: 'PICHILEMU',
                id: '5606201'
            },
            {
                name: 'PLACILLA',
                id: '5606308'
            },
            {
                name: 'QUINTA DE TILCOCO',
                id: '5606114'
            },
            {
                name: 'RANCAGUA',
                id: '5606101'
            },
            {
                name: 'RENGO',
                id: '5606115'
            },
            {
                name: 'REQUINOA',
                id: '5606601'
            },
            {
                name: 'SAN FERNANDO',
                id: '5606301'
            },
            {
                name: 'SAN VICENTE',
                id: '5606117'
            },
            {
                name: 'SANTA CRUZ',
                id: '5606310'
            }
        ],
        id: '6',
        code: 'OH'
    },
    {
        name: 'LOS LAGOS',
        comunas: [
            {
                name: 'ANCUD',
                id: '5610202'
            },
            {
                name: 'CALBUCO',
                id: '5610102'
            },
            {
                name: 'CASTRO',
                id: '5610201'
            },
            {
                name: 'FRESIA',
                id: '5610104'
            },
            {
                name: 'FRUTILLAR',
                id: '5610105'
            },
            {
                name: 'LLANQUIHUE',
                id: '5610107'
            },
            {
                name: 'LOS MUERMOS',
                id: '5610106'
            },
            {
                name: 'MAULLIN',
                id: '5610108'
            },
            {
                name: 'OSORNO',
                id: '5610301'
            },
            {
                name: 'PUERTO MONTT',
                id: '5610101'
            },
            {
                name: 'PUERTO VARAS',
                id: '5610109'
            },
            {
                name: 'PUQUELDON',
                id: '5610206'
            },
            {
                name: 'PURRANQUE',
                id: '5610303'
            },
            {
                name: 'QUELLON',
                id: '5610208'
            },
            {
                name: 'QUINCHAO',
                id: '5610210'
            },
            {
                name: 'RIO NEGRO',
                id: '5610305'
            },
            {
                name: 'SAN JUAN DE LA COSTA',
                id: '5610306'
            },
            {
                name: 'SAN PABLO',
                id: '5610307'
            }
        ],
        id: '10',
        code: 'LL'
    },
    {
        name: 'LOS RÍOS',
        comunas: [
            {
                name: 'FUTRONO',
                id: '5614202'
            },
            {
                name: 'LA UNION',
                id: '5614201'
            },
            {
                name: 'LAGO RANCO',
                id: '5614203'
            },
            {
                name: 'LANCO',
                id: '5614103'
            },
            {
                name: 'LOS LAGOS',
                id: '5614104'
            },
            {
                name: 'MAFIL',
                id: '5614105'
            },
            {
                name: 'MARIQUINA',
                id: '5614106'
            },
            {
                name: 'PAILLACO',
                id: '5614107'
            },
            {
                name: 'PANGUIPULLI',
                id: '5614108'
            },
            {
                name: 'RIO BUENO',
                id: '5614204'
            },
            {
                name: 'VALDIVIA',
                id: '5614101'
            }
        ],
        id: '14',
        code: 'LR'
    },
    {
        name: 'MAGALLANES Y DE LA ANTÁRTICA CHILENA',
        comunas: [
            {
                name: 'NATALES',
                id: '5612401'
            },
            {
                name: 'PUNTA ARENAS',
                id: '5612101'
            }
        ],
        id: '12',
        code: 'MA'
    },
    {
        name: 'MAULE',
        comunas: [
            {
                name: 'CAUQUENES',
                id: '5607201'
            },
            {
                name: 'COLBUN',
                id: '5607402'
            },
            {
                name: 'CONSTITUCION',
                id: '5607102'
            },
            {
                name: 'CUREPTO',
                id: '5607103'
            },
            {
                name: 'CURICO',
                id: '5607301'
            },
            {
                name: 'HUALANE',
                id: '5607302'
            },
            {
                name: 'LICANTEN',
                id: '5607303'
            },
            {
                name: 'LINARES',
                id: '5607401'
            },
            {
                name: 'LONGAVI',
                id: '5607403'
            },
            {
                name: 'MAULE',
                id: '5607105'
            },
            {
                name: 'MOLINA',
                id: '5607304'
            },
            {
                name: 'PARRAL',
                id: '5607404'
            },
            {
                name: 'PELARCO',
                id: '5607106'
            },
            {
                name: 'PENCAHUE',
                id: '5607107'
            },
            {
                name: 'RAUCO',
                id: '5607305'
            },
            {
                name: 'RETIRO',
                id: '5607405'
            },
            {
                name: 'RIO CLARO',
                id: '5607108'
            },
            {
                name: 'ROMERAL',
                id: '5607306'
            },
            {
                name: 'SAGRADA FAMILIA',
                id: '5607307'
            },
            {
                name: 'SAN CLEMENTE',
                id: '5607109'
            },
            {
                name: 'SAN JAVIER',
                id: '5607406'
            },
            {
                name: 'SAN RAFAEL',
                id: '5607110'
            },
            {
                name: 'TALCA',
                id: '5607101'
            },
            {
                name: 'TENO',
                id: '5607308'
            },
            {
                name: 'VICHUQUEN',
                id: '5607309'
            },
            {
                name: 'VILLA ALEGRE',
                id: '5607407'
            },
            {
                name: 'YERBAS BUENAS',
                id: '5607408'
            }
        ],
        id: '7',
        code: 'ML'
    },
    {
        name: 'METROPOLITANA DE SANTIAGO',
        comunas: [
            {
                name: 'BUIN',
                id: '5613402'
            },
            {
                name: 'CALERA DE TANGO',
                id: '5613403'
            },
            {
                name: 'CERRILLOS',
                id: '5613102'
            },
            {
                name: 'CERRO NAVIA',
                id: '5613103'
            },
            {
                name: 'COLINA',
                id: '5613301'
            },
            {
                name: 'CONCHALI',
                id: '5613104'
            },
            {
                name: 'CURACAVI',
                id: '5613503'
            },
            {
                name: 'EL BOSQUE',
                id: '5613105'
            },
            {
                name: 'EL MONTE',
                id: '5613602'
            },
            {
                name: 'ESTACION CENTRAL',
                id: '5613106'
            },
            {
                name: 'HUECHURABA',
                id: '5613107'
            },
            {
                name: 'INDEPENDENCIA',
                id: '5613108'
            },
            {
                name: 'ISLA DE MAIPO',
                id: '5613603'
            },
            {
                name: 'LA CISTERNA',
                id: '5613109'
            },
            {
                name: 'LA FLORIDA',
                id: '5613110'
            },
            {
                name: 'LA GRANJA',
                id: '5613111'
            },
            {
                name: 'LA PINTANA',
                id: '5613112'
            },
            {
                name: 'LA REINA',
                id: '5613113'
            },
            {
                name: 'LAMPA ',
                id: '5613302'
            },
            {
                name: 'LAS CONDES',
                id: '5613114'
            },
            {
                name: 'LO BARNECHEA',
                id: '5613115'
            },
            {
                name: 'LO ESPEJO',
                id: '5613116'
            },
            {
                name: 'LO PRADO',
                id: '5613117'
            },
            {
                name: 'MACUL',
                id: '5613118'
            },
            {
                name: 'MAIPU',
                id: '5613119'
            },
            {
                name: 'MARIA PINTO',
                id: '5613504'
            },
            {
                name: 'MELIPILLA',
                id: '5613501'
            },
            {
                name: 'NUÑOA',
                id: '5613120'
            },
            {
                name: 'PADRE HURTADO',
                id: '5613604'
            },
            {
                name: 'PAINE',
                id: '5613404'
            },
            {
                name: 'PEDRO AGUIRRE CERDA',
                id: '5613121'
            },
            {
                name: 'PEÑAFLOR',
                id: '5613605'
            },
            {
                name: 'PEÑALOLEN',
                id: '5613122'
            },
            {
                name: 'PIRQUE',
                id: '5613202'
            },
            {
                name: 'PROVIDENCIA',
                id: '5613123'
            },
            {
                name: 'PUDAHUEL',
                id: '5613124'
            },
            {
                name: 'PUENTE ALTO',
                id: '5613201'
            },
            {
                name: 'QUILICURA',
                id: '5613125'
            },
            {
                name: 'QUINTA NORMAL',
                id: '5613126'
            },
            {
                name: 'RECOLETA',
                id: '5613127'
            },
            {
                name: 'RENCA',
                id: '5613128'
            },
            {
                name: 'SAN BERNARDO',
                id: '5613401'
            },
            {
                name: 'SAN JOAQUIN',
                id: '5613129'
            },
            {
                name: 'SAN JOSE DE MAIPO',
                id: '5613203'
            },
            {
                name: 'SAN MIGUEL',
                id: '5613130'
            },
            {
                name: 'SAN PEDRO',
                id: '5613505'
            },
            {
                name: 'SAN RAMON',
                id: '5613131'
            },
            {
                name: 'SANTIAGO CENTRO',
                id: '5613101'
            },
            {
                name: 'TALAGANTE',
                id: '5613601'
            },
            {
                name: 'TILTIL',
                id: '5613303'
            },
            {
                name: 'VITACURA',
                id: '5613132'
            }
        ],
        id: '13',
        code: 'RM'
    },
    {
        name: 'ÑUBLE',
        comunas: [
            {
                name: 'BULNES',
                id: '5616109'
            },
            {
                name: 'CHILLAN',
                id: '5616107'
            },
            {
                name: 'CHILLAN VIEJO',
                id: '5616108'
            },
            {
                name: 'COBQUECURA',
                id: '5616207'
            },
            {
                name: 'COELEMU',
                id: '5616206'
            },
            {
                name: 'EL CARMEN',
                id: '5616101'
            },
            {
                name: 'ÑIQUEN',
                id: '5616302'
            },
            {
                name: 'QUILLON',
                id: '5616104'
            },
            {
                name: 'QUIRIHUE',
                id: '5616203'
            },
            {
                name: 'RANQUIL',
                id: '5616204'
            },
            {
                name: 'SAN CARLOS',
                id: '5616303'
            },
            {
                name: 'SAN FABIAN',
                id: '5616304'
            },
            {
                name: 'YUNGAY',
                id: '5616106'
            }
        ],
        id: '16',
        code: 'NU'
    },
    {
        name: 'TARAPACÁ',
        comunas: [
            {
                name: 'ALTO HOSPICIO',
                id: '5601107'
            },
            {
                name: 'CAMIÑA',
                id: '5601402'
            },
            {
                name: 'COLCHANE',
                id: '5601403'
            },
            {
                name: 'IQUIQUE',
                id: '5601101'
            },
            {
                name: 'PICA',
                id: '5601405'
            },
            {
                name: 'POZO ALMONTE',
                id: '5601401'
            }
        ],
        id: '1',
        code: 'TA'
    },
    {
        name: 'VALPARAÍSO',
        comunas: [
            {
                name: 'ALGARROBO',
                id: '5605602'
            },
            {
                name: 'CABILDO',
                id: '5605402'
            },
            {
                name: 'CALERA',
                id: '5605502'
            },
            {
                name: 'CALLE LARGA',
                id: '5605302'
            },
            {
                name: 'CARTAGENA',
                id: '5605603'
            },
            {
                name: 'CASABLANCA',
                id: '5605102'
            },
            {
                name: 'CATEMU',
                id: '5605702'
            },
            {
                name: 'CONCON',
                id: '5605103'
            },
            {
                name: 'EL QUISCO',
                id: '5605604'
            },
            {
                name: 'EL TABO',
                id: '5605605'
            },
            {
                name: 'HIJUELAS',
                id: '5605503'
            },
            {
                name: 'LA CRUZ',
                id: '5605504'
            },
            {
                name: 'LA LIGUA',
                id: '5605401'
            },
            {
                name: 'LAGUNA VERDE',
                id: '5605111'
            },
            {
                name: 'LIMACHE',
                id: '5605802'
            },
            {
                name: 'LLAILLAY',
                id: '5605703'
            },
            {
                name: 'LOS ANDES',
                id: '5605301'
            },
            {
                name: 'NOGALES',
                id: '5605506'
            },
            {
                name: 'OLMUE',
                id: '5605803'
            },
            {
                name: 'PANQUEHUE',
                id: '5605704'
            },
            {
                name: 'PAPUDO',
                id: '5605403'
            },
            {
                name: 'PUCHUNCAVI',
                id: '5605105'
            },
            {
                name: 'PUTAENDO',
                id: '5605705'
            },
            {
                name: 'QUILLOTA',
                id: '5605501'
            },
            {
                name: 'QUILPUE',
                id: '5605801'
            },
            {
                name: 'QUINTERO',
                id: '5605107'
            },
            {
                name: 'SAN ANTONIO',
                id: '5605601'
            },
            {
                name: 'SAN ESTEBAN',
                id: '5605304'
            },
            {
                name: 'SAN FELIPE',
                id: '5605701'
            },
            {
                name: 'SANTA MARIA',
                id: '5605706'
            },
            {
                name: 'SANTO DOMINGO',
                id: '5605606'
            },
            {
                name: 'VALPARAISO',
                id: '5605101'
            },
            {
                name: 'VILLA ALEMANA',
                id: '5605804'
            },
            {
                name: 'VIÑA DEL MAR',
                id: '5605109'
            },
            {
                name: 'ZAPALLAR',
                id: '5605405'
            }
        ],
        id: '5',
        code: 'VA'
    }
]
